const root = '/report';

export default {
  root,
} as const;
